import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-3",
  style: {"font-size":"16px"}
}
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_6 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  style: {"font-size":"16px"}
}
const _hoisted_7 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_16 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-3 p-lg-3"
}
const _hoisted_17 = { class: "p-field p-col-4 p-sm-4 p-md-3" }
const _hoisted_18 = { enctype: "multipart/form-data" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_21 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_23 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_24 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_28 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_29 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_30 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_31 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Panel, { header: "Tra cứu thông tin CLS của bệnh nhân" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Mã y tế", -1)),
              _createVNode(_component_InputText, {
                id: "name",
                type: "text",
                modelValue: $setup.maYTe,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.maYTe) = $event)),
                style: {"text-align":"center","font-size":"16px"}
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Tra cứu", -1)),
              _createVNode(_component_Button, {
                label: "Tìm",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.loadListCls())),
                style: {"font-size":"16px"}
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      ($setup.listCLS.length > 0)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 0,
            header: "Thông tin bệnh nhân"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Mã y tế", -1)),
                  _createVNode(_component_InputText, {
                    id: "maYTe",
                    type: "text",
                    modelValue: $setup.listCLS[0].mayte,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.listCLS[0].mayte) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Họ và tên", -1)),
                  _createVNode(_component_InputText, {
                    id: "hoVaTen",
                    type: "text",
                    modelValue: $setup.listCLS[0].tenbenhnhan,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.listCLS[0].tenbenhnhan) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Ngày sinh", -1)),
                  _createVNode(_component_InputText, {
                    id: "ngaySinh",
                    modelValue: $setup.ngaySinh,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.ngaySinh) = $event)),
                    type: "text",
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Giới tính", -1)),
                  _createVNode(_component_InputText, {
                    id: "gioiTinh",
                    type: "text",
                    modelValue: $setup.listCLS[0].gioitinh,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.listCLS[0].gioitinh) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { style: {"font-size":"16px"} }, "CCCD/CMND", -1)),
                  _createVNode(_component_InputText, {
                    id: "cmnd",
                    type: "text",
                    modelValue: $setup.listCLS[0].cmnd,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.listCLS[0].cmnd) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Số điện thoại", -1)),
                  _createVNode(_component_InputText, {
                    id: "dt",
                    type: "text",
                    modelValue: $setup.listCLS[0].sodienthoai,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.listCLS[0].sodienthoai) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { style: {"font-size":"16px"} }, "Địa chỉ thường trú", -1)),
                  _createVNode(_component_InputText, {
                    id: "diaChi",
                    type: "text",
                    modelValue: $setup.listCLS[0].diachithuongtru,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.listCLS[0].diachithuongtru) = $event)),
                    style: {"text-align":"center","font-size":"16px"},
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_Button, {
                    class: "p-button-outlined",
                    label: "Thêm kết quả CLS",
                    onclick: "document.getElementById('myFile').click()",
                    icon: "pi pi-paperclip"
                  })
                ]),
                ($setup.listFileName.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_Button, {
                        label: "Gởi kết quả cho bệnh nhân",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.upload())),
                        icon: "pi pi-send",
                        style: {"margin-right":"5vw"},
                        severity: "warning"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("form", _hoisted_18, [
                    _createElementVNode("input", {
                      id: "myFile",
                      type: "file",
                      style: {"display":"none"},
                      accept: ".pdf",
                      name: "files",
                      onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.fileChange($event.target.files))),
                      disabled: $setup.loadingBar
                    }, null, 40, _hoisted_19)
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      (!$setup.permissionCLS)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 0,
            header: "Dữ liệu kết quả CLS"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_DataTable, {
                    loading: _ctx.isLoading,
                    value: $setup.listFileCls,
                    paginator: true,
                    stripedRows: "",
                    rows: 30,
                    rowsPerPageOptions: [30,50,100],
                    rowHover: true,
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[13] || (_cache[13] = ($event: any) => (($setup.filters) = $event)),
                    paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                    globalFilterFields: ['tendichvu'],
                    currentPageReportTemplate: "Có tổng số {totalRecords} dữ liệu kết quả   CLS",
                    columnResizeMode: "fit | expand"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Button, {
                          type: "button",
                          icon: "pi pi-filter-slash",
                          label: "Xoá",
                          class: "p-button-outlined",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.clearFilter())),
                          style: {"width":"6em"}
                        }),
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(_component_InputText, {
                            modelValue: $setup.filters['global'].value,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.filters['global'].value) = $event)),
                            placeholder: "Tìm theo dịch vụ"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "fullName",
                        header: "Tên tài khoản gởi",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "time",
                        header: "Thời gian gởi",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.time)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "path",
                        header: "Tên tập tin",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "trangThai",
                        header: "Tình trạng",
                        sortable: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          (slotProps.data.trangThai)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_25, "Đã gởi dữ liệu cho khách hàng"))
                            : (_openBlock(), _createElementBlock("label", _hoisted_26, "Chưa gởi dữ liệu cho khách hàng "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, { header: "Tùy chọn" }, {
                        body: _withCtx((slotProps) => [
                          (!slotProps.data.trangThai)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                severity: "secondary",
                                label: "Gởi cho khách hàng",
                                icon: "pi pi-sent",
                                onClick: ($event: any) => ($setup.sendFileResult(slotProps.data.id))
                              }, null, 8, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                severity: "danger",
                                label: "Gởi lại cho khách hàng",
                                icon: "pi pi-sent",
                                onClick: ($event: any) => ($setup.sendFileResult(slotProps.data.id))
                              }, null, 8, ["onClick"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "value", "filters"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_Panel, { header: "Danh sách dịch vụ CLS" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_DataTable, {
                loading: _ctx.isLoading,
                value: $setup.listCLS,
                paginator: true,
                stripedRows: "",
                rows: 30,
                rowsPerPageOptions: [30,50,100],
                rowHover: true,
                filters: $setup.filters,
                "onUpdate:filters": _cache[16] || (_cache[16] = ($event: any) => (($setup.filters) = $event)),
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['tendichvu'],
                currentPageReportTemplate: "Có tổng số {totalRecords} dịch vụ CLS",
                columnResizeMode: "fit | expand"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"6em"}
                    }),
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm theo dịch vụ"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "tendichvu",
                    header: "Tên dịch vụ",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "ngaygioyeucau",
                    header: "Thời gian yêu cầu",
                    sortable: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.ngaygioyeucau)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "value", "filters"])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}